module.exports = __webpack_public_path__ + "media/images/profile_bg-6163244900365918890e3d32750b09fa.png";